import { t } from '@lingui/macro';
import { CcsDocumentFlushReason } from 'shared/domains/apollo/generated/types';
import { useGetUsers } from './useGetUsers';
export const useReasonTexts = (reason, initiatorUserId) => {
    var _a;
    const { users } = useGetUsers();
    const fallbackName = t({
        message: 'Unknown',
        comment: 'RTC Document flushed - Fallback name for unknown user',
    });
    const userName = ((_a = users.find(user => user.id === initiatorUserId)) === null || _a === void 0 ? void 0 : _a.name) || fallbackName;
    switch (reason) {
        case CcsDocumentFlushReason.Converted:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Converted - Dialog title',
                    message: 'Document converted to free-text',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Converted - Dialog content',
                    message: `The document has been converted to free-text by ${userName}`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Converted - Dialog button label',
                    message: 'Reload document',
                }),
            };
        case CcsDocumentFlushReason.Deleted:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Deleted - Dialog title',
                    message: 'Document deleted',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Deleted - Dialog content',
                    message: `The document has been deleted by ${userName}`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Deleted - Dialog button label',
                    message: 'Go back',
                }),
            };
        case CcsDocumentFlushReason.Locked:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Locked - Dialog title',
                    message: 'Document locked',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Locked - Dialog content',
                    message: `The document has been locked by ${userName}`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Locked - Dialog button label',
                    message: 'Close',
                }),
            };
        case CcsDocumentFlushReason.Unlocked:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Unlocked - Dialog title',
                    message: 'Document unlocked',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Unlocked - Dialog content',
                    message: `The document has been unlocked by ${userName}`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Unlocked - Dialog button label',
                    message: 'Close',
                }),
            };
        case CcsDocumentFlushReason.SigningStatusPending:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Signing status pending - Dialog title',
                    message: 'Document sent for eSigning',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Signing status pending - Dialog content',
                    message: `The document has been sent for eSigning by ${userName}`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Signing status pending - Dialog button label',
                    message: 'Close',
                }),
            };
        case CcsDocumentFlushReason.SigningStatusCancelled:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Signing status cancelled - Dialog title',
                    message: 'Document eSigning cancelled',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Signing status cancelled - Dialog content',
                    message: `The document eSigning has been cancelled by ${userName}`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Signing status cancelled - Dialog button label',
                    message: 'Close',
                }),
            };
        case CcsDocumentFlushReason.SigningStatusRejected:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Signing status rejected - Dialog title',
                    message: 'Document eSigning declined',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Signing status rejected - Dialog content',
                    message: `The document eSigning has been declined`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Signing status rejected - Dialog button label',
                    message: 'Close',
                }),
            };
        case CcsDocumentFlushReason.EditingWithTemplate:
            return {
                modalTitle: t({
                    comment: 'RTC Document flushed - Reason: Editing with template - Dialog title',
                    message: 'Editing with template started',
                }),
                modalContent: t({
                    comment: 'RTC Document flushed - Reason: Editing with template - Dialog content',
                    message: `${userName} has started editing the document with the template editor.`,
                }),
                buttonLabel: t({
                    comment: 'RTC Document flushed - Reason: Editing with template - Dialog button label',
                    message: 'Go back',
                }),
            };
        default:
            return null;
    }
};
